module.exports = __webpack_public_path__ + "static/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.be2953b2.png";